<template>
    <header>
        <h1><img src="@/assets/line-mv.webp" alt="あなたの借金問題、LINEから解決できます"></h1>
        <p>[PR]弁護士法人ラピス法律事務所</p>
    </header>
</template>

<script>
export default {
    name: 'Header'
}
</script>

<style scoped lang="scss">
header {
    width: 100%;
    p {
        text-align: right;
        padding: 0 20px;
        font-size: 14px;
        opacity: 0.5;
    }
    img {
        filter: drop-shadow(0px 3px 3px #00000033);
    }
    h1 {
        font-size: 1.25rem;
        font-weight: bold;
        margin: auto;
        text-align: center;
        margin: 0;
        position: relative;
        display: inline-block;
    }
}
</style>
